import { FetchRequest } from "@rails/request.js"

export default class FileUploader {
  constructor(controller) {
    this.controller = controller
  }

  async uploadFile(file, previewElement) {
    const formData = this.buildFormData(file)

    try {
      const response = await this.makeUploadRequest(formData)
      const data = await response.json

      this.handleUploadSuccess(data, previewElement)

    } catch (error) {
      console.error('Upload error:', error)
      this.handleUploadError(error, previewElement)
    }
  }

  buildFormData(file) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('filename', file.name)
    formData.append('content_type', file.type)

    if (this.controller.hasRecordTypeValue && this.controller.hasRecordIdValue) {
      formData.append('record_type', this.controller.recordTypeValue)
      formData.append('record_id', this.controller.recordIdValue)
      formData.append('field_name', this.controller.attributeNameValue)
    }

    return formData
  }

  async makeUploadRequest(formData) {
    const request = new FetchRequest('POST', '/madmin/attachments/direct_uploads', {
      body: formData
    })

    const response = await request.perform()

    if (!response.ok) {
      const errorText = await response.text()
      console.error(`Upload failed with status ${response.status}: ${errorText}`)
      throw new Error(`Upload failed: ${response.statusText}`)
    }

    return response
  }

  handleUploadSuccess(data, previewElement) {
    if (this.controller.isNewRecord() && !data.isTemporary && data.signed_id) {
      this.addHiddenInput(data.signed_id)
    }
    this.controller.tableManager.addImageToTable(data)
    this.controller.previewManager.removePreviewElement(previewElement)
    this.controller.previewManager.checkAndHidePreviewContainer()
  }

  handleUploadError(error, previewElement) {
    this.controller.previewManager.updatePreviewAfterUpload(previewElement, false, error.message)
  }

  addHiddenInput(signedId) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `${this.controller.recordTypeValue.toLowerCase()}[${this.controller.attributeNameValue}][]`
    input.value = signedId
    this.controller.element.appendChild(input)
  }
}